import React from 'react';
import LeadActivity from '@/components/Lead/LeadActivity';
import { LeadDetailsModel } from '@/typings/models/Lead';

export interface ActivitiesDrawerProps {
  leadId: string;
  leadDetails: LeadDetailsModel;
}

const ActivitiesDrawer: React.FC<ActivitiesDrawerProps> = ({ leadDetails }) => {
  return <LeadActivity leadDetails={leadDetails} />;
};

export default ActivitiesDrawer;
